import React from "react"

import { ProductPosition } from "shared/types/ProductPosition"
import {
  isProjectProductPosition,
  isProjectProductPositionAddon,
  isProjectRoom
} from "shared/types/Project"
import { Room } from "shared/types/Room"
import { ProductPositionAddon } from "shared/types/__generated__/graphql"
import { RowRendererProps } from "shared/ui/table/types"

import { ProductPositionTableProductPositionAddonRow } from "./rows/product-position-addon/ProductPositionTableProductPositionAddonRow"
import { ProductPositionTableProductPositionRowConnector } from "./rows/product-position/ProductPositionTableProductPositionRowConnector"
import { ProductPositionTableRoomRowConnector } from "./rows/room/ProductPositionTableRoomRowConnector"

export const ProductPositionTableRow = React.memo(
  (props: RowRendererProps<ProductPosition | ProductPositionAddon | Room>) => {
    const { item } = props
    if (isProjectProductPositionAddon(item)) {
      return (
        <ProductPositionTableProductPositionAddonRow {...props} item={item} />
      )
    }
    if (isProjectProductPosition(item)) {
      return (
        <ProductPositionTableProductPositionRowConnector
          {...props}
          item={item}
        />
      )
    }
    if (isProjectRoom(item)) {
      return <ProductPositionTableRoomRowConnector {...props} item={item} />
    }
    return null
  }
)
